var path = 'views/display/placeholder.html';
var html = "<div class=\"fd-m-field fd-m-placeholder\"></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;